import { showMessage, loadingEnd, showError, showPopup, closePopup } from "./uiActions";
import { saveAs } from 'file-saver'
import { setCustomerMessage } from "./userActions"

export function getPresentations(flag = true) {
    return function (dispatch) {
        if (flag) {
            dispatch(showPopup("loadingPopup", "Loading Presentations..."))
        }
        dispatch(presFlipSwitch())
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
                }
            })
            .then((json) => {
                if (flag) {
                    dispatch(closePopup())
                }
                dispatch(setCustomerMessage(json.message))
                return dispatch(loadPresentations(json.presentationList));
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Get Presentations Failed"))
            })
    }
}

export function getPresentation(id) {
    return function (dispatch) {
        dispatch(setIsPresentationBigLoaded(false));
        dispatch(singlePresFlipSwitch())
        dispatch(getPresentationBig(id))
    }
}

export function alertPresentationIsReady(id) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/small`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                return dispatch(showMessage(`Your presentation was updated and is ready to view. ${json.pres.presentation.isStory ? "Presentation may be used for stories" : "Presentation cannot be used for stories"}.`, true));
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Get Presentation Failed", false))
            })
    }
}

export function sendEditPresentationInfo(connInfoID, customerDatabaseID, folderID, presID, customerID, isTemplate, teamIDs, tagIDs, databaseSelections) {
    console.log("sendEditPresentationInfo");
    console.log(databaseSelections);
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                ConnInfoID: connInfoID,
                folderID: folderID,
                CustomerDatabaseID: customerDatabaseID,
                PresID: parseInt(presID),
                CustomerID: customerID,
                IsTemplate: isTemplate,
                TeamIDs: teamIDs,
                TagIDs: tagIDs,
                DatabaseSelections: databaseSelections
            })
        }).then((resp) => {
            // console.log(resp)
            if (resp.status !== 200) {
                throw new Error()
            } else {
                dispatch(getPresentations())
                return dispatch(showPopup("confirmationPopup", "Presentation Edit was Successful", true))
            }
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Presentation Edit Failed", false))
        })
    }
}

export function getPresentationBig(id) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/big`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            dispatch(setIsPresentationBigLoaded(true));
            return dispatch(loadPresentation(json.pres));
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Get Presentation Failed", false))
        });
    }
}

export function getSlideNotesDifferenceTextOnly(id) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/notesAndSlidesTextOnly/${id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(setSlideChanges(json.slideComparison));
        }).catch((ex) => {
            console.log(ex);
        });
    }
}

export function getSlideNotesDifference(id) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/notesAndSlides/${id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(setSlideChanges(json.slideComparison));
        }).catch((ex) => {
            console.log(ex);
        });
    }
}


export function uploadPresentation(data) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Uploading Presentation..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/upload`, {
            method: 'POST',
            body: data,
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`,
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                if (resp.status === 400) {
                    throw new Error("Virus Scanner Error");
                } else {
                    throw new Error(resp.json)
                }
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                dispatch(showPopup("confirmationPopup", "Upload Presentation was Successful", true));
                return dispatch(getPresentations());
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Upload Presentation Failed", false));
        });
    }
}

export function updatePresentation(data) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Updating Presentation..."));
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/update`, {
            method: 'POST',
            body: data,
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`,
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            dispatch(showPopup("confirmationPopup", "Update Presentation was Successful", true));
            return dispatch(getPresentations());
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Update Presentation Failed", false));
        });
    }
}

export function refreshPresentation(id, documentTypeId, connId, changedGlobalSetName, globals, editQuickPickIDs, quickPickAliases, dimensionAliases) {
    console.log('***',id, documentTypeId, connId, changedGlobalSetName, globals, editQuickPickIDs, quickPickAliases)
    
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Refreshing Presentation..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/refresh`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                PresentationID: id,
                DocumentTypeId: documentTypeId,
                ConnID: connId,
                ChangedGlobalSet: changedGlobalSetName,
                GlobalList: globals,
                EditQuickPickIDs: editQuickPickIDs,
                QuickPickAliases: quickPickAliases,
                DimensionAliases: dimensionAliases
            }),
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
            .then((json) => {  
                return dispatch(showPopup("confirmationPopup", "Presentation Has Been Sent to Queue", true));
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup","Refresh Presentation Failed", false))
            })

    }
}

export function refreshPresentationWithQuickPickTags(id, globals, quickPickTags) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Refreshing Presentation..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/refreshWithQuickPickTags`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                PresentationID: id,
                GlobalList: globals,
                QuickPickTags: quickPickTags,
            }),
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                return (dispatch(showPopup("confirmationPopup", "Refresh Presentation has Been Sent to Queue", true)))
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Refresh Presentation Failed", false))
            })

    }
}

export function refreshPresentationSlide(id, documentTypeId, connId, xp3SlideId, querySelections, trends, isTemplate, chartId) {
    console.log('***', id, documentTypeId, connId, xp3SlideId, querySelections, trends);

    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Refreshing Charts..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/refreshSlide`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                PresentationID: id,
                DocumentTypeId: documentTypeId,
                ConnID: connId,
                XP3SlideId: [xp3SlideId],
                Selections: querySelections,
                Trends: trends,
                ChartID: chartId
            }),
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                if (isTemplate === true) {
                    return (dispatch(showPopup("confirmationPopup", "Refresh Presentation has Been Sent to Queue", true)))
                } else {
                    return (dispatch(showPopup("loadingPopup", "Refreshing Charts...")))
                }
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Refresh Presentation Failed", false))
            })
    }
}

export function createChildPresentation(id, newName, slides) {
    console.log('***', id, newName, slides);

    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Creating New Presentation..."))

        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/createChildPresentation`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                PresentationID: id,
                PresentationName: newName,
                TagIds: slides
            }),
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(showPopup("confirmationPopup", "Create New Presentation Was Successful", true));
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Create New Presentation Failed", false))
        });
    }
}

export function updateStory(id, slides) {
    console.log('***', id, slides);

    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Updating Presentation..."))

        let slideTagOrdering = [];
        let iterator = 0;
        slides.forEach(s => {
            slideTagOrdering.push({
                Tag: s.tag,
                Parent: s.parent,
                Order: iterator
            });
            iterator++;
        });

        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/updateStory`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                PresentationID: id,
                Slides: slideTagOrdering
            }),
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(showPopup("confirmationPopup", "Update Story Sent To Queue", true));
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Update Presentation Failed", false))
        });
    }
}

export function updateChildPresentation(id, slides) {
    console.log('***', id, slides);

    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Updating Child Presentation..."));

        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/updateChildPresentation`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                PresentationID: id,
                TagIds: slides
            }),
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            return dispatch(showPopup("confirmationPopup", "Update Child Presentation was Successful", true));
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Update Child Presentation Failed", false))
        });
    }
}

export function getConnectionInfos(presentationID, documentTypeID) {
    return function (dispatch) {
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${presentationID}/${documentTypeID}/connectionInfos`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`,
            },

        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
            }).then((json) => {
                return dispatch(setConnInfos(json.connInfos))
            }).catch((ex) => {
                return dispatch(showMessage("Get Connection Infos Failed", false))
            })
    }
}

export function clearPresentationProgress(id) {
    return { type: 'CLEAR_PRESENTATION_PROGRESS', presID: id}
}

export function deletePresentation(id) {
    return function (dispatch) {
        // dispatch(loadingStart())
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}`, {
            method: 'DELETE',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                dispatch(getPresentations(false))
                return dispatch(showPopup("confirmationPopup", "Presentation Successfully Deleted"))
            }).catch((ex) => {
                return dispatch(showPopup("confirmationPopup", "Presentation was not Successfully Deleted"))
            })
    }
}

export function sendRenamePresentation(id, name) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Renaming Presentation..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}`, {
            method: 'PATCH',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                PresID: id,
                Name: name,
            }),
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
        .then((json) => {
            dispatch(showPopup("confirmationPopup", "Presentation Successfully Renamed"))
            return dispatch(getPresentations())
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Presentation wasn't renamed, please try again"))
        })

    }
}

export function downloadPresentation(id, fileName) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Preparing Presentation for Download"))
        dispatch(downloadCheck())                
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/${id}/download`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            // console.log(resp)
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.blob()
            }
            }).then(blob => {
                saveAs(blob, fileName)
                return dispatch(showPopup("confirmationPopup", "Download Starting Now..."))
            })
            .catch((ex) => {
                dispatch(showError())
                dispatch(loadingEnd())
                return dispatch(showPopup("confirmationPopup", "Download Presentation Failed", false))
            })
    }
}

export function getTags() {
    return function (dispatch) {        
        fetch(`${process.env.REACT_APP_BACK_URL}/presentations/tags`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
                if (resp.status !== 200) {
                    throw new Error()
                } else {
                    return resp.json()
                }
            })
            .then((json) => {
                return dispatch(loadTags(json.presTags))
            }).catch((ex) => {
                return dispatch(showMessage("Get Tags Failed", false))
            })
    }
}

export function getPresentationSlideImage(id) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/presentations/getPresentationSlideImage/${id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

export function getSlideImagesAndCharts(id) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/presentations/getSlideImagesAndCharts/${id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

export function getIndividualSlideImagesAndCharts(id, slideId) {
    return function (dispatch) {
        return fetch(`${process.env.REACT_APP_BACK_URL}/presentations/getIndividualSlideImagesAndCharts/${id}/${slideId}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        })
    }
}

export function clearPresentationView() {
    return { type: 'CLEAR_PRESENTATION_VIEW' }
}

export function showPresentationsProgress(presID, message) {
    return { type: 'SHOW_PRESENTATIONS_PROGRESS', presID: presID, message: message }
}

export function downloadCheck() {
    return { type: 'DOWNLOAD_PRESENTATION_CHECK' }
}

export function loadPresentations(payload) {
   return { type: 'LOAD_PRESENTATIONS', payload }
}

export function loadPresentation(payload) {
    return { type: 'LOAD_PRESENTATION', payload }
}

export function presFlipSwitch() {
    return { type: 'FLIP_PRESENTATIONS_SWITCH' }
}

export function singlePresFlipSwitch() {
    return { type: 'FLIP_SINGLE_PRESENTATION_SWITCH' }
}

export function setConnInfos(payload) {
    return { type: 'SET_CONNECTION_INFOS', payload }
}

export function setIsPresentationBigLoaded(payload) {
    return { type: 'SET_IS_PRESENTATION_BIG_LOADED', payload }
}

export function loadTags(payload) {
    return { type: 'LOAD_PRESENTATION_TAGS', payload }
}

export function setSlideChanges(payload) {
    return { type: 'SLIDE_CHANGES', payload };
}